export default __webpack_public_path__ + "static/media/img5.04ff5ca4.jpg";